// NOTE: these are sample stand-ins — swap in real customer words as they come in.
export const REVIEWS = [
  {
    quote: "The baby blanket is even softer in person — you can feel the care in every stitch. It's the gift everyone at the shower kept asking about.",
    name: "A happy gift-giver",
    item: "Baby Blanket",
  },
  {
    quote: "My daughter hasn't put her stuffie down since it arrived. Beautifully made, safely stitched, and so full of personality.",
    name: "A grateful mom",
    item: "Custom Stuffie",
  },
  {
    quote: "Ordered a hat and scarf set in my favourite colours and they fit perfectly. Quick replies, fair pricing, and such lovely work.",
    name: "A warm customer",
    item: "Hat & Scarf Set",
  },
];
